import React, { ReactNode, ErrorInfo } from 'react';
import * as Sentry from '@sentry/react';
import GenericError from './GenericError';
import { useTracking } from '../tracking/TrackingContext';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { Tracking } = useTracking();
    Tracking.Error.boundaryError(error.message);

    const errorInfoObject = {
      componentStack: errorInfo.componentStack,
    };
    Sentry.captureException(error, { extra: errorInfoObject });

    if (error.message.includes('removeEventListener')) {
      this.setState({ hasError: false });
    }
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <GenericError />;
    }

    return children;
  }
}

export default ErrorBoundary;
